export const CUSTOMER_SESSION_EXPIRED = 'customer-session-expired';
export const APPLICATION_SESSION_EXPIRED = 'application-session-expired';
export const CUSTOMER_LOGIN = 'customer-login';
export const APPLICATION_LOGIN = 'application-login';
export const JOB_PROFILE_APPLICANT_EXCLUDED = 'job-profile-applicant-excluded';
export const JOB_PROFILE_APPLICANT_EXCLUSION_REMOVED = 'job-profile-applicant-exclusion-removed';
export const JOB_PROFILE_APPLICANT_LIST_ITEM_ACTION = 'job-profile-applicant-list-item-action';
export const SHOW_FEEDBACK = 'show-feedback';
export const SHOW_CONSENT = 'show-consent';
export const MESSAGE_FAN_CLOSED = 'message-fan-closed';
